import routes from './../routes'
import vue from 'vue'
import {filterResponse, filterErrors} from './../client'

export const getRecent = (limit) => {
    const useUrl = limit ? `${routes.billsPayment.recent}?limit=${limit}` : routes.billsPayment.recent
    return vue.http.get(useUrl).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getRecurring = () => {
    return vue.http.get(routes.billsPayment.recurring).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getSaved = () => {
    return vue.http.get(routes.billsPayment.saved).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getHistory = () => {
    return vue.http.get(routes.billsPayment.history).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const getCategories = () => {
    return vue.http.get(routes.billsPayment.categories ).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getCategory = (id) => {
    return vue.http.get(routes.billsPayment.category + id).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getCategoryBillers = (id) => {
    return vue.http.get(routes.billsPayment.category + id + '/billers').then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const postCustomerDetails = (id) => {
    return vue.http.post(routes.billsPayment.customerDetails + id).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const postPay = (data) => {
    //add details
    data.authorizationCode = Date.now() + '_' + data.client.id;
    data.channel= 'web';

    return vue.http.post(routes.billsPayment.pay).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
